import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'rsuite/dist/rsuite.min.css';
// Design token layer — loads theme.css (:root CSS variables) + tailwind base globally.
// This must come after vendor CSS so our tokens are not overridden.
import './styles/index.css';
import { createRoot } from 'react-dom/client';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
    <App />
    </LocalizationProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
